import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";

interface TechItem {
  name: string;
  logo: string;
}

const technologies: TechItem[] = [
  { name: "React", logo: "https://cdn.simpleicons.org/react/61DAFB" },
  { name: "Next.js", logo: "https://cdn.simpleicons.org/nextdotjs/FFFFFF" },
  { name: "Node.js", logo: "https://cdn.simpleicons.org/nodedotjs/5FA04E" },
  { name: "Laravel", logo: "https://cdn.simpleicons.org/laravel/FF2D20" },
  { name: "PHP", logo: "https://cdn.simpleicons.org/php/777BB4" },
  { name: "WordPress", logo: "https://cdn.simpleicons.org/wordpress/21759B" },
  { name: "MongoDB", logo: "https://cdn.simpleicons.org/mongodb/47A248" },
  { name: "MySQL", logo: "https://cdn.simpleicons.org/mysql/4479A1" },
  { name: "AWS", logo: "https://cdn.simpleicons.org/amazonwebservices/FF9900" },
];

const WdevTechnologies: React.FC = () => {
  return (
    <section className="wdev-tech" aria-labelledby="wdev-tech-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="wdev-tech-title" className="wdev-section-head__title">
            Technologies We Use
          </h2>
        </AnimatedSection>

        <div className="wdev-tech__grid">
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.name}
              className="wdev-tech-card"
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
            >
              <div className="wdev-tech-card__logo">
                <img src={tech.logo} alt={`${tech.name} logo`} loading="lazy" />
              </div>
              <span className="wdev-tech-card__name">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WdevTechnologies;
